// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.4.1-2bW5h7N5TLEKpP3hb61d/mode=imports,min/optimized/keen-slider.js'

class ProductMediaCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.slideEls || this.slideEls.length < 2) return
    this.carousel = this.initialiseCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.dotEls.forEach(dotEl => {
      this.listeners.add(dotEl, 'click', this.handleDotClick.bind(this))
    })
  }

  initialiseCarousel () {
    this.dataset.autoplay = true
    this.autoplay(true)

    return new KeenSlider(this.slidesEl, {
      mode: 'snap',
      loop: true,
      slides: {
        perView: 1,
        spacing: 0,
      },
      selector: this.els?.slide?.selector,
      slideChanged: instance => {
        this.dotEls.forEach(dotEl => {
          dotEl.setAttribute(
            'aria-current',
            dotEl.dataset.index ===
              (instance?.track?.details?.rel + 1).toString(),
          )
        })
      },
      dragStarted: () => {
        this.dataset.autoplay = false
        this.autoplay(false)
      },
    })
  }

  handleDotClick (e) {
    this.dotEls.forEach(dotEl => {
      dotEl.setAttribute(
        'aria-current',
        dotEl.dataset.index === e.target.dataset.index,
      )
    })

    this.carousel.moveToIdx(parseInt(e.target.dataset.index, 10) - 1)
  }

  autoplay (run) {
    clearInterval(this.interval)

    this.interval = setInterval(() => {
      if (run && this.carousel) {
        this.carousel.next()
      }
    }, 3000)
  }

  get slidesEl () {
    return this.els?.slides?.element
  }

  get slideEls () {
    return this.els?.slide?.elements
  }

  get dotEls () {
    return this.els?.dot?.elements
  }

  get indexEl () {
    return this.els?.index?.element
  }
}

if (!customElements.get('product-media-carousel')) {
  customElements.define('product-media-carousel', ProductMediaCarousel)
}
